import { getIconProps, type IconProps } from '#types'

/**
 * Profile icon — single person silhouette (head + shoulders).
 *
 * Used for profile navigation and account-related sections.
 *
 * @example
 * ```tsx
 * <ProfileIcon className="size-5" />
 * ```
 */
export function ProfileIcon({ strokeWidth = 1.5, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M12 20.25C13.6391 20.25 14.9316 20.2087 15.9512 20.1025C16.9779 19.9956 17.6757 19.8269 18.1523 19.6035C18.6034 19.392 18.8476 19.1368 18.999 18.8174C19.1643 18.4687 19.25 17.9788 19.25 17.25C19.25 16.5253 19.1655 15.9901 18.9883 15.5811C18.8204 15.1936 18.5522 14.8791 18.0967 14.6172C17.1139 14.0521 15.305 13.75 12 13.75C8.69497 13.75 6.88606 14.0521 5.90332 14.6172C5.44784 14.8791 5.17961 15.1936 5.01172 15.5811C4.83452 15.9901 4.75 16.5253 4.75 17.25C4.75 17.9788 4.83572 18.4687 5.00098 18.8174C5.1524 19.1368 5.3966 19.392 5.84766 19.6035C6.32428 19.8269 7.02212 19.9956 8.04883 20.1025C9.06838 20.2087 10.3609 20.25 12 20.25Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3.75C10.0258 3.75 8.38574 5.40701 8.38574 7.5C8.38574 9.59299 10.0258 11.25 12 11.25C13.974 11.2498 15.6133 9.59286 15.6133 7.5C15.6133 5.40714 13.974 3.7502 12 3.75Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}
